import React from "react";
import "../styles/HeroMain.css";

export default function HeroMain() {
  return (
    <div className="heromain">
      {/* Serving responsive images as background with help of media queries. */}
    </div>
  );
}
